var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
export class CalendarState {
    constructor() {
        this.width = window.innerWidth - 100;
        this.height = window.innerHeight - 100;
        this.filteractive = false;
        makeObservable(this);
        window.addEventListener('resize', () => {
            this.setHeight(window.innerHeight - 100);
            this.setWidth(window.innerWidth - 100);
        });
    }
    setFilterActive(filteractive) {
        this.filteractive = filteractive;
    }
    setWidth(width) {
        this.width = width;
    }
    setHeight(height) {
        this.height = height;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], CalendarState.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CalendarState.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CalendarState.prototype, "filteractive", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CalendarState.prototype, "setFilterActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], CalendarState.prototype, "setWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], CalendarState.prototype, "setHeight", null);
